var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotes20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3381_14296",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3381_14296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75602 14.5C3.54367 14.5 3.36458 14.4285 3.21875 14.2856C3.07292 14.1427 3 13.9656 3 13.7544C3 13.5431 3.07182 13.3646 3.21546 13.2188C3.35911 13.0729 3.53711 13 3.74946 13H11.244C11.4563 13 11.6354 13.0715 11.7812 13.2144C11.9271 13.3573 12 13.5344 12 13.7456C12 13.9569 11.9282 14.1354 11.7845 14.2812C11.6409 14.4271 11.4629 14.5 11.2505 14.5H3.75602ZM3.75 10.75C3.5375 10.75 3.35938 10.6785 3.21563 10.5356C3.07188 10.3927 3 10.2156 3 10.0044C3 9.79313 3.07188 9.61458 3.21563 9.46875C3.35938 9.32292 3.5375 9.25 3.75 9.25H16.25C16.4625 9.25 16.6406 9.32145 16.7844 9.46435C16.9281 9.60727 17 9.78435 17 9.9956C17 10.2069 16.9281 10.3854 16.7844 10.5312C16.6406 10.6771 16.4625 10.75 16.25 10.75H3.75ZM3.75 7C3.5375 7 3.35938 6.92855 3.21563 6.78565C3.07188 6.64273 3 6.46565 3 6.2544C3 6.04313 3.07188 5.86458 3.21563 5.71875C3.35938 5.57292 3.5375 5.5 3.75 5.5H16.25C16.4625 5.5 16.6406 5.57145 16.7844 5.71435C16.9281 5.85727 17 6.03435 17 6.2456C17 6.45687 16.9281 6.63542 16.7844 6.78125C16.6406 6.92708 16.4625 7 16.25 7H3.75Z",
    fill: "black",
    fillOpacity: 0.6
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes20);
export default __webpack_public_path__ + "static/media/notes-20.dc25d927176adb8c355a22b997ecf3b4.svg";
export { ForwardRef as ReactComponent };